import React, { useState } from 'react';
import { Users, Building2, GraduationCap, Heart, ChevronDown, ChevronUp } from 'lucide-react';
import Footer from '../components/Footer';

const StaffDirectory = () => {
  const [expandedBuildings, setExpandedBuildings] = useState({
    'Z066/X582': true,
    'Z468/X468': false,
    'Z153/X497': false
  });

  const toggleBuilding = (code) => {
    setExpandedBuildings(prev => ({
      ...prev,
      [code]: !prev[code]
    }));
  };

  // Source: the school's Table of Organization 26-27 sheets (Ogden Ave Z066/X582,
  // Aurelia Greene Z468/X468, 3rd Ave Z153/X497), received 2026-10-20.
  // "(S)" and "LTA" are the sheets' own markers and are shown as written.
  const buildings = {
    'Z066/X582': {
      name: '1434 Ogden Avenue, Bronx, NY 10452 · (718) 583-8975',
      leadership: [
        { name: 'Mr. Vincenzo Rosignano', title: 'Principal', room: '115A', ext: '1162' },
        { name: 'Mr. Patrick Kelly', title: 'Principal', room: '112', ext: '1121' },
        { name: 'Ms. Gisselle Canela-Espinal', title: 'Assistant Principal', room: '108', ext: '1081' },
        { name: 'Ms. Keyla Llorente', title: 'Site Coordinator', room: '115A', ext: '1161' },
        { name: 'Mr. Louis Garcia', title: 'Special Education Coordinator', room: '1091', ext: '1091' }
      ],
      officeSupport: [
        { name: 'Ms. Dannia Velasquez', title: 'Secretary', room: '115A', ext: '1161' },
        { name: 'Ms. Abigail Freeland', title: 'Parent Coordinator', room: '117', ext: '1142' }
      ],
      classrooms: [
        {
          garden: 'Garden 1 (Pre-K)',
          room: '113',
          ext: '1131',
          teacher: 'Ms. Hanan Elaskandrany',
          assistant: 'Mr. Cristian Casado'
        },
        {
          garden: 'Garden 2 (3K)',
          room: '111',
          ext: '1111',
          teacher: 'Ms. Ana Perez',
          assistant: 'Ms. Yolanda Perez'
        },
        {
          garden: 'Garden 3 (3K)',
          room: '105',
          ext: '1051',
          teacher: 'Ms. Aquanetta Joe',
          assistant: 'Ms. Mya Motley'
        },
        {
          garden: 'Garden 4 (SCIS)',
          room: '103',
          ext: '1031',
          teachers: ['Mr. Pedro Ramos', 'Ms. Robinann Gordon'],
          assistants: ['Mr. Deivis Cuello', 'Ms. Myra Baradales - LTA']
        },
        {
          garden: 'Garden 5 (Pre-K)',
          room: '104',
          ext: '1041',
          teacher: 'Ms. Katie Newmark',
          assistant: 'Ms. Jahada Rasul'
        }
      ],
      coverage: [
        { name: 'Ms. Silibeth Gomez (S)', title: 'Teacher', room: null, ext: null },
        { name: 'Ms. Nicole Rodriguez (S)', title: 'Educational Assistant', room: null, ext: null }
      ],
      cluster: [
        { name: 'Ms. Jerriann Jaloza', title: 'Social Studies', room: null, ext: null },
        { name: 'Mr. Brandyn Albanese', title: 'Physical Education', room: null, ext: null }
      ],
      relatedServices: [
        { name: 'Ms. Lisa Seetoe', title: 'Physical Therapist', room: null, ext: null },
        { name: 'Ms. Olivia Cheng', title: 'Occupational Therapist', room: null, ext: null },
        { name: 'Ms. Shellynette Garcia', title: 'Speech', room: null, ext: null }
      ],
      support: [
        { name: 'Ms. Barbra Asafu-Adjie', title: 'School Nurse', room: '116', ext: '1181' },
        { name: 'SSA Wendy Ortiz', title: 'School Safety Agent', location: 'Lobby/Front Desk', ext: '1000' },
        { name: 'Mr. Ivan Crispin', title: 'Custodian', room: '123', ext: '1232' },
        { name: 'Ms. Sheba Tate', title: 'School Aide', room: '108', ext: '1082' }
      ]
    },
    'Z468/X468': {
      name: '1302 Edward L. Grant Hwy (Aurelia Greene Campus), Bronx, NY 10452 · (646) 298-1850 Ext. 1084',
      leadership: [
        { name: 'Mr. Vincenzo Rosignano', title: 'Principal', room: null, ext: null },
        { name: 'Mr. Patrick Kelly', title: 'Principal', room: null, ext: null },
        { name: 'Ms. Gisselle Canela-Espinal', title: 'Assistant Principal', room: null, ext: null },
        { name: 'Ms. Adrienne Marquez', title: 'Site Coordinator', room: null, ext: null },
        { name: 'Mr. Louis Garcia', title: 'Special Education Coordinator', room: null, ext: null },
        { name: 'Ms. Portia Yeboah', title: 'Special Education Coordinator', room: null, ext: null }
      ],
      officeSupport: [
        { name: 'Ms. Dannia Velasquez', title: 'Secretary', room: null, ext: null },
        { name: 'Ms. Abigail Freeland', title: 'Parent Coordinator', room: null, ext: null }
      ],
      classrooms: [
        {
          garden: 'Garden 15 (6:1:2)',
          room: '119',
          ext: '1191',
          teacher: 'Ms. Sherry Emmanuel Goitia',
          assistants: ['Ms. Maria Tejeda', 'Ms. Ginnette Regalado']
        },
        {
          garden: 'Garden 16 (8:1:2)',
          room: '118',
          ext: '1181',
          teacher: 'Ms. Shaquana Ashley',
          assistants: ['Ms. Hannah Freeland', 'Ms. Obatossi Dos Reis', '1:1 Ms. Crista Spence (S)']
        },
        {
          garden: 'Garden 17 (8:1:2)',
          room: '107',
          ext: '1071',
          teacher: 'Ms. Crystal Estrada',
          assistants: ['Ms. Madley De La Rosa - LTA', 'Ms. Edible Colon (S)']
        },
        {
          garden: 'Garden 18 (12:1:2)',
          room: '103',
          ext: '1031',
          teacher: 'Ms. Jennifer Ahmad',
          assistants: ['Ms. Luz Jimenez (S)', 'Mr. Yuliane Almanzar', 'Mr. Alexander Gil']
        }
      ],
      cluster: [
        { name: 'Ms. Nayorbi Lopez', title: 'Social Studies', room: null, ext: null },
        { name: 'Mr. Jovanie Adames', title: 'Physical Education', room: null, ext: null },
        { name: 'Ms. Taifa Jones', title: 'Art', room: null, ext: null }
      ],
      relatedServices: [
        { name: 'Ms. Lisa Seetoe', title: 'Physical Therapist', room: '120', ext: '1201' },
        { name: 'Ms. Shuyi Pan', title: 'Occupational Therapist', room: '120', ext: '1201' },
        { name: 'Vacancy', title: 'Occupational Therapist', room: '120', ext: '1201' },
        { name: 'Ms. Sofia Lugo', title: 'Speech', room: '120', ext: '1201' },
        { name: 'Ms. Monica Morales', title: 'Speech', room: '120', ext: '1201' }
      ],
      support: [
        { name: 'Ms. Jone', title: 'School Nurse', room: null, ext: '1092' },
        { name: 'SSA Reeves', title: 'School Safety Agent', room: null, ext: '1000' },
        { name: 'Mr. Henry', title: 'Custodian', room: null, ext: '5161' }
      ]
    },
    'Z153/X497': {
      name: '4179 Third Avenue, Bronx, NY 10457 · (929) 688-4547',
      leadership: [
        { name: 'Mr. Vincenzo Rosignano', title: 'Principal', room: '112', ext: '1121' },
        { name: 'Mr. Patrick Kelly', title: 'Principal', room: '112', ext: '1121' },
        { name: 'Ms. Pamela Rossi', title: 'Assistant Principal', room: '109', ext: '1091' },
        { name: 'Mr. Louis Garcia', title: 'Special Education Coordinator', room: '108', ext: '1081' }
      ],
      officeSupport: [
        { name: 'Ms. Emily Rojas', title: 'Secretary', room: '108', ext: '1082' },
        { name: 'Ms. Abigail Freeland', title: 'Parent Coordinator', room: '1091', ext: '1091' }
      ],
      classrooms: [
        {
          garden: 'Garden 6 (12:1:2)',
          room: '107',
          ext: '1071',
          teacher: 'Ms. Jewel Hoyte',
          assistants: ['Ms. Towanda Banks', 'Mr. Junior Zorrilla']
        },
        {
          garden: 'Garden 7 (8:1:2)',
          room: '109',
          ext: '1091',
          teacher: 'Ms. Danielle Medina',
          assistants: ['Ms. Whitney Small', 'Ms. Haydee Medina']
        },
        {
          garden: 'Garden 8 (8:1:2)',
          room: '118',
          ext: '1181',
          teacher: 'Ms. Nicole Flores',
          assistants: ['Ms. Jaqueline Rosado', 'Ms. Jazzeray Castillo']
        },
        {
          garden: 'Garden 9 (6:1:2)',
          room: '122',
          ext: '1221',
          teacher: 'Ms. Marlene Toledo',
          assistants: ['Ms. Raquel Javier', 'Mr. Austin Bedoya']
        },
        {
          garden: 'Garden 10 (8:1:2)',
          room: '124',
          ext: '1241',
          teacher: 'Mr. Jose Ovalle',
          assistants: ['Ms. Jiovanna Sanchez', 'Ms. Imalay Santiago', '1:1 Ms. Veronica Rojas (S)']
        },
        {
          garden: 'Garden 11 (3K)',
          room: '113',
          ext: '1131',
          teacher: 'Mr. Joel Dogelio',
          assistant: 'Ms. Estefani Eusebio'
        },
        {
          garden: 'Garden 12 (3K SCIS)',
          room: '115',
          ext: '1151',
          teachers: ['Ms. Manyely Garcia Ogando', 'Ms. Anna Sagan'],
          assistants: ['Ms. Janeya Hayward', 'Mr. Francis Rosario (S)']
        },
        {
          garden: 'Garden 13 (4K SCIS)',
          room: '130',
          ext: '1301',
          teachers: ['Ms. Romena Rouf', 'Ms. Karina Aponte'],
          assistants: ['Ms. Jasmin Reynoso', 'Mr. Stephen Sharpe (S)']
        },
        {
          garden: 'Garden 14 (4K)',
          room: '117',
          ext: '1171',
          teacher: 'Ms. Violeta Taylor',
          assistant: 'Ms. Wendy Rojas (S)'
        }
      ],
      coverage: [
        { name: 'Ms. Ginnie Ortiz (S)', title: 'Teacher (Tue, Thu, Fri)', room: null, ext: null },
        { name: 'Mr. Emerson Rodriguez (S)', title: 'Teacher', room: null, ext: null },
        { name: 'Ms. Lilly Davis (S)', title: 'Educational Assistant', room: null, ext: null },
        { name: 'Mr. Killean Dilland (S)', title: 'Educational Assistant', room: null, ext: null },
        { name: 'Ms. Taneisha Ritchens (S)', title: 'Educational Assistant', room: null, ext: null },
        { name: 'Ms. Kenia Deleon', title: 'Educational Assistant', room: null, ext: null },
        { name: 'Mr. Lydell Barry (S)', title: 'Educational Assistant', room: null, ext: null }
      ],
      cluster: [
        { name: 'Mr. Jose Heyiame', title: 'STEAM', room: null, ext: null },
        { name: 'Ms. Marytery Caceres', title: 'Social Studies', room: null, ext: null },
        { name: 'Mr. Samil Gomez', title: 'Physical Education', room: '134', ext: null },
        { name: 'Ms. Gleiry Feliz', title: 'Math', room: null, ext: null }
      ],
      relatedServices: [
        { name: 'Ms. Lisa Seetoe', title: 'Physical Therapist', room: '109', ext: null },
        { name: 'Ms. Olivia Cheng', title: 'Occupational Therapist', room: '109', ext: null },
        { name: 'Ms. Karen Wassner', title: 'Occupational Therapist', room: '109', ext: null },
        { name: 'Ms. Teryn Bieler', title: 'Occupational Therapist', room: '109', ext: null },
        { name: 'Ms. Julia Cohen', title: 'Speech', room: '109', ext: null },
        { name: 'Mr. Dante Centeno', title: 'Speech', room: '109', ext: null },
        { name: 'Ms. Octavia Oesricher-Nieves', title: 'Speech', room: '109', ext: null }
      ],
      support: [
        { name: 'Ms. Deborah Owusu', title: 'School Nurse', room: '126', ext: '1261' },
        { name: 'SSA Philips', title: 'School Safety Agent', location: 'Lobby/Front Desk', ext: '1000' },
        { name: 'Mr. Cirano Parades / Mr. Victor', title: 'Custodian', room: '123', ext: '1232' }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16 sm:mb-20">
          <span className="text-[#7d5800] font-semibold text-sm uppercase tracking-[0.15em]">Our Team</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#123f1e] mt-4 leading-[1.15] tracking-tight">
            Staff Directory
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 mt-6 leading-relaxed font-light max-w-3xl mx-auto">
            Meet the dedicated professionals across our three campuses who make learning bloom every day
          </p>
        </header>

        {/* Staff Team Image */}
        <div className="mb-16">
          <img
            src="/assets/images/gallery/District9PreK-189.jpg"
            alt="Our dedicated staff team"
            className="w-full max-w-5xl mx-auto h-96 object-cover rounded-3xl shadow-xl"
          />
        </div>

        {/* Buildings */}
        {Object.entries(buildings).map(([code, building], buildingIndex) => (
          <div key={code} className="mb-8">
            <button
              onClick={() => toggleBuilding(code)}
              aria-expanded={expandedBuildings[code]}
              aria-controls={`building-panel-${buildingIndex}`}
              className="w-full bg-[#123f1e] text-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#febc04] focus:ring-offset-2"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-[#febc04]/20 rounded-xl backdrop-blur-sm border border-[#febc04]/30">
                    <Building2 className="w-6 h-6 text-[#febc04]" />
                  </div>
                  <div className="text-left">
                    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Building Code: {code}</h2>
                    <p className="text-white/80 text-sm sm:text-base mt-1 font-light">{building.name}</p>
                  </div>
                </div>
                {expandedBuildings[code] ? (
                  <ChevronUp className="w-6 h-6 text-[#febc04]" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-[#febc04]" />
                )}
              </div>
            </button>

            {expandedBuildings[code] && (
              <div id={`building-panel-${buildingIndex}`} role="region" aria-label={`${code} staff details`} className="mt-6 space-y-8 animate-fade-in">
                {/* Leadership */}
                <StaffSection
                  title="Leadership Team"
                  icon={<GraduationCap className="w-6 h-6" />}
                  staff={building.leadership}
                />

                {/* Office Support */}
                <StaffSection
                  title="Office Support"
                  icon={<Users className="w-6 h-6" />}
                  staff={building.officeSupport}
                  bgColor="bg-[#febc04]/5"
                />

                {/* Classrooms */}
                <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#123f1e]/10 rounded-xl">
                      <GraduationCap className="w-6 h-6 text-[#123f1e]" />
                    </div>
                    <h3 className="text-2xl font-bold text-[#123f1e] tracking-tight">Classrooms (Gardens)</h3>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    {building.classrooms.map((classroom, idx) => (
                      <div key={idx} className="bg-gray-50/50 border border-gray-200 rounded-xl p-5 hover:border-[#febc04] transition-all duration-200">
                        <h4 className="font-bold text-[#123f1e] mb-3">{classroom.garden}</h4>
                        <div className="space-y-2 text-sm">
                          <p className="text-gray-600">
                            <span className="font-semibold text-gray-800">Room:</span> {classroom.room}
                            {classroom.ext && <span className="ml-2">| <span className="font-semibold text-gray-800">Ext:</span> {classroom.ext}</span>}
                          </p>
                          {classroom.teacher && (
                            <p className="text-gray-700">
                              <span className="font-semibold text-[#123f1e]">Teacher:</span> {classroom.teacher}
                            </p>
                          )}
                          {classroom.teachers && (
                            <div>
                              <span className="font-semibold text-[#123f1e]">Teachers:</span>
                              <ul className="ml-4 mt-1">
                                {classroom.teachers.map((t, i) => (
                                  <li key={i} className="text-gray-700">• {t}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {classroom.assistant && (
                            <p className="text-gray-700">
                              <span className="font-semibold text-[#123f1e]">Educational Assistant:</span> {classroom.assistant}
                            </p>
                          )}
                          {classroom.assistants && (
                            <div>
                              <span className="font-semibold text-[#123f1e]">Educational Assistants:</span>
                              <ul className="ml-4 mt-1">
                                {classroom.assistants.map((a, i) => (
                                  <li key={i} className="text-gray-700">• {a}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Enrichment/Cluster Programs */}
                {building.enrichment && (
                  <StaffSection
                    title="Enrichment Partner Teachers"
                    icon={<Heart className="w-6 h-6" />}
                    staff={building.enrichment}
                    bgColor="bg-[#febc04]/5"
                  />
                )}

                {building.coverage && (
                  <StaffSection
                    title="Coverage Staff"
                    icon={<Users className="w-6 h-6" />}
                    staff={building.coverage}
                  />
                )}

                {building.cluster && (
                  <StaffSection
                    title="Cluster (Push-in)"
                    icon={<Heart className="w-6 h-6" />}
                    staff={building.cluster}
                    bgColor="bg-[#febc04]/5"
                  />
                )}

                {/* Push-In Services */}
                {building.pushIn && (
                  <StaffSection
                    title="Push-In Services"
                    icon={<Heart className="w-6 h-6" />}
                    staff={building.pushIn}
                    bgColor="bg-[#febc04]/5"
                  />
                )}

                {/* Related Services */}
                <StaffSection
                  title="Related Service Providers"
                  icon={<Heart className="w-6 h-6" />}
                  staff={building.relatedServices}
                />

                {/* Support Staff */}
                <StaffSection
                  title="School Support Staff"
                  icon={<Users className="w-6 h-6" />}
                  staff={building.support}
                  bgColor="bg-gray-50/50"
                />
              </div>
            )}
          </div>
        ))}

        {/* Contact Note */}
        <div className="mt-12 bg-[#123f1e] rounded-2xl p-8 text-white text-center shadow-md">
          <p className="text-lg font-light leading-relaxed">
            For additional information or to contact a specific staff member, please call our main office at{' '}
            <a href="tel:718-583-8975" className="font-semibold text-[#febc04] hover:underline focus:outline-none focus:underline">
              (718) 583-8975
            </a>
          </p>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

// Reusable Staff Section Component
const StaffSection = ({ title, icon, staff, bgColor = 'bg-white' }) => (
  <div className={`${bgColor} border border-gray-200 rounded-2xl p-6 sm:p-8`}>
    <div className="flex items-center gap-3 mb-6">
      <div className="p-3 bg-[#123f1e]/10 rounded-xl">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-[#123f1e] tracking-tight">{title}</h3>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {staff.map((member, idx) => (
        <div key={idx} className="bg-white border border-gray-200 rounded-xl p-4 hover:border-[#febc04] transition-all duration-200 shadow-sm">
          <h4 className="font-bold text-[#123f1e] mb-1 text-sm">{member.name}</h4>
          <p className="text-xs text-gray-600 mb-2">{member.title}</p>
          {member.room && (
            <p className="text-xs text-gray-500">
              <span className="font-semibold">Room:</span> {member.room}
              {member.ext && <span className="ml-2">| <span className="font-semibold">Ext:</span> {member.ext}</span>}
            </p>
          )}
          {member.location && (
            <p className="text-xs text-gray-500">
              <span className="font-semibold">Location:</span> {member.location}
              {member.ext && <span className="ml-2">| <span className="font-semibold">Ext:</span> {member.ext}</span>}
            </p>
          )}
          {!member.room && !member.location && member.ext && (
            <p className="text-xs text-gray-500">
              <span className="font-semibold">Ext:</span> {member.ext}
            </p>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default StaffDirectory;
